import type { User } from "@/lib/auth";
import { userContext } from "./UserContext";
interface Props {
	initialUser?: User;
	children: React.ReactNode;
}

export const UserProvider: React.FC<Props> = ({ children, initialUser }) => {
	return (
		<userContext.Provider value={{ user: initialUser }}>
			{children}
		</userContext.Provider>
	);
};
